var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"withdraw-limit"},[_c('div',{attrs:{"infinite-scroll-disabled":true}},_vm._l((_vm.imgUrls),function(item,index){return _c('img',{key:index,attrs:{"src":_vm.youpPath+item}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }